import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { QuotaItem } from '../../_models/quota-item';
import { QuotaMovement } from '../../_models/quota-movement';
import { QuotaService } from '../../_services/quota.service';

import { QuotaShip } from '../../_models/quotaship';
import { QuotaShipService } from '../../_services/quotaship.service';

import { Profile } from '../../_models/profile';

import { NotificationsService } from '../../_services/notifications.service';

@Component({
  selector: 'app-quota-detail',
  templateUrl: './quota-detail.component.html',
  styleUrls: ['./quota-detail.component.css'],
})
export class QuotaDetailComponent extends Form implements OnInit {
  public quotaShips: QuotaShip[];
  public profile: Profile;

  constructor(
    private quotaService: QuotaService,
    private quotaShipService: QuotaShipService,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler,
    protected notificationsService: NotificationsService
  ) {
    super(route, httpErrorHandler);
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.initialize(this.quotaService, new QuotaItem());
    this.get();
    this.setFormMode('update');
  }

  updateQuota(data, field) {
    this.instance[field] = data.value;
    this.quotaService.update(this.instance.serialize()).subscribe(
      (instance) => {
        this.instance.real_amount = instance['real_amount'];
        this.notificationsService.notify('success', 'Actualización', 'Edición completada');
      },
      (error) => {
        this.instance[field] = data.oldValue;
        const msn = (error.body[field] && error.body[field][0]) || error.body['non_field_errors'];
        this.notificationsService.notify('error', 'Error', msn);
      }
    );
  }

  deleteQuotaMovement(quotaMovement: QuotaMovement) {
    this.quotaService.deleteMovement(quotaMovement.id).subscribe(
      (empty) => {
        this.onDelete(quotaMovement);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  onDelete(quotaMovement) {
    const index = this.instance.movements.indexOf(quotaMovement, 0);
    if (index > -1) {
      this.instance.movements.splice(index, 1);
    }
    this.refreshQuota();
    this.notificationsService.notify('success', 'Eliminar movimiento', 'Se ha eliminado el movimiento correctamente');
  }

  refreshQuota() {
    this.get();
  }

  public onLoad(quota: QuotaItem) {
    this.getQuotaShipDetails(quota);
  }

  private getQuotaShipDetails(quota) {
    const urlParams = new URLSearchParams();
    urlParams.append('quota', quota.id);
    this.quotaShips = [];

    this.quotaShipService.list(1, 10000, urlParams.toString(), '').subscribe(
      (response) => {
        for (const record of response.results) {
          this.quotaShips.push(QuotaShip.apiMap(record));
        }
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-detail/quota-detail.component.ts